import axios from 'axios';
import history from './history';
import alertify from 'alertifyjs';
import store from './store'
import Password from 'antd/lib/input/Password';
import { MSGAltaUsuario } from './components/librerias/herramientas'


const parseParams = (params = "") => {
    const rawParams = params.replace("?", "").split("&");
    const extractedParams = {};
    rawParams.forEach((item) => {
        item = item.split("=");
        extractedParams[item[0]] = item[1];
    });
    return extractedParams;
};



const sendRegistroModdle = user => {
    let esInvitacion = store.getState().aceptoInvitacion;
    let curso = store.getState().idCurso;

    let params = parseParams(window.location.search);
    user.idSocio = params.socio !== undefined ? params.socio : null;



    var qs = require('qs');
    let campos = ""
    for (var x in user) {
        if (user[x] === "") {
            campos += x + ","
        }
    }

    if (curso === "") {
        campos += " selecciona un curso";
    }


    if (campos !== "") {
        alertify.set('notifier', 'position', 'top-right');
        alertify.warning('Faltan los siguientes campos:' + campos);
    } else {
        axios({
            method: 'post',
            url: 'https://registroreevolucion.servicenext.eu/Api/api/Academy/Registro',
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({
                "NOMBRE": user.nombre,
                "APELLIDO1": user.apellido1,
                "APELLIDO2": user.apellido2,
                "EMAIL": user.email,
                "TELEFONO": user.telefono,
                "CIF": user.cif,
                "ID_SOCIO": parseInt(user.idSocio),
                "ID_CURSO": curso,
                "INDEPENDIENTE": esInvitacion ? 1 : 0
            })
        }).then(function (res) {
            if (!res.data.OK) {
                alertify.set('notifier', 'position', 'top-right');
                alertify.warning('Problemas al crear el usuario');
            } else {
                MSGAltaUsuario();
                alertify.set('notifier', 'position', 'top-right');
                alertify.success('Usuario dado de alta');

                store.dispatch({
                    type: "SET_STATE_USER",
                    user: { nombre: "", apellido1: "", apellido2: "", email: "", telefono: "", cif: "", idSocio: "" }
                })
            }
        });
    }
}

const accesoAdministrador = password => {
    //let buscarSocio = parseParams(window.location.search);
    //store.dispatch({ type: "SET_STATE_SOCIO", idSocio: buscarSocio.socio })
    //history.push("/home");
    axios({
        method: 'post',
        url: 'https://registroreevolucion.servicenext.eu/Api/api/Login/getloginACADEMY_CLOUD',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            "USUARIO": "Administrador",
            "PWD": password,
            "PLATAFORMA": "ACADEMY_CLOUD",
            "ID_TALLER": ""
        })
    }).then(function (res) {
        if (res.data.OK) {
            //saveUrl();
            localStorage.setItem('tokenACADEMY', res.data.Token);


            //let obtenerIDSOCIO = store.getState().user;

            history.push("/home");
        } else {
            alertify.set('notifier', 'position', 'top-right');
            alertify.warning('Contraseña incorrecta.');
        }
    });
}

const logOut = () => {
    axios({
        method: 'post',
        url: 'https://registroreevolucion.servicenext.eu/Api/api/ACADEMY_CLOUD/LogOut',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            "Token": localStorage.getItem("tokenACADEMY")
        })
    }).then(function (res) {
        if (res.data.OK) {
        }
    });
}


const buscarTodosLosUsuariosRegistrados = (idcursoInterno) => {
    store.dispatch({ type: "STATE_ALL_USER", allDataUser: {} })

    axios({
        method: 'post',
        url: 'https://registroreevolucion.servicenext.eu/Api/api/Academy/getDatosRegistrosCurso',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            "REGSPAGE": 5000,
            "PAGE": 1,
            "ORDERCOLUM": 1,
            "ORDERDIR": "A",
            "EMAIL": "",
            "NOMBRE": "",
            "CIF": "",
            "TALLER": "",
            "SOCIO": "",
            "ID_SOCIO": "",
            "ID_CURSO": idcursoInterno,
            "Token": localStorage.getItem("tokenACADEMY")
        })
    }).then(function (res) {
        if (!res.data.OK) {
            alertify.set('notifier', 'position', 'top-right');
            alertify.warning(res.data.mensajeError);

            store.dispatch({ type: "STATE_ACTIVO_DESCARGA", activeButtonDescargar: true })
            store.dispatch({ type: "STATE_ACTIVO_CERRAR_CURSO", activebuttonEliminar: true })
        } else {
            if (res.data.RegistroCursos === null) {
                store.dispatch({ type: "STATE_ALL_USER", allDataUser: {} })
                store.dispatch({ type: "STATE_ACTIVO_DESCARGA", activeButtonDescargar: true })
                store.dispatch({ type: "STATE_ACTIVO_CERRAR_CURSO", activebuttonEliminar: true })
            } else {
                store.dispatch({ type: "STATE_ACTIVO_DESCARGA", activeButtonDescargar: false })
                store.dispatch({ type: "STATE_ACTIVO_CERRAR_CURSO", activebuttonEliminar: false })
                store.dispatch({ type: "STATE_ALL_USER", allDataUser: res.data })
            }
        }
    });
}

const crearFichero = () => {
    let estadoActual = store.getState().allDataUser;
    if (estadoActual.RegistroCursos === undefined) {
        alertify.set('notifier', 'position', 'top-right');
        alertify.warning('No hay datos para crear el fichero');
    } else {
        if (estadoActual.RegistroCursos.length > 0) {
            var crearLinea = "username;password;firstname;lastname;email;phone1;description;cohort1";

            estadoActual.RegistroCursos.map((i, pos) => {
                crearLinea += "\n" + i.EMAIL.trim() + ";" + "1234" + ";" + i.NOMBRE.trim() + ";" + i.APELLIDO_1.trim() + ";" + i.EMAIL.trim() + ";" + i.TELEFONO.trim() + ";" + i.CIF.trim() + ";" + i.SOCIO.trim();
            })

            var randomNum = Math.floor(Math.random() * 100) + 1;
            var blob = new Blob([crearLinea], { type: "text/plain;charset=utf-8" });
            saveFile(blob, "documento" + randomNum + ".txt")

        } else {
            alertify.set('notifier', 'position', 'top-right');
            alertify.warning('No hay datos para crear el fichero');
        }
    }
    /*
        var randomNum = Math.floor(Math.random() * 100) + 1;
        var blob = new Blob(["This is my first text\nnueva linea"], {type: "text/plain;charset=utf-8"});
        saveFile(blob,"documento"+ randomNum +".txt")
        */
}


const eliminarRegistros = () => {
    let cursoCerrar = store.getState().idcursoCerrar;
    let obtenerIDSOCIO = store.getState().user;
    axios({
        method: 'post',
        url: 'https://registroreevolucion.servicenext.eu/Api/api/Academy/Cerrar_Registro',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            "NOMBRE": "",
            "APELLIDO1": "",
            "APELLIDO2": "",
            "EMAIL": "",
            "PWD": "",
            "TELEFONO": "",
            "CIF": "",
            "ID_CURSO": cursoCerrar,
            "ID_SOCIO": "",
            "Token": localStorage.getItem("tokenACADEMY")
        })
    }).then(function (res) {
        //refrecar combo porque se elimina el curso
        if (!res.data.OK) {
            alertify.set('notifier', 'position', 'top-right');
            alertify.warning('Problemas al eliminar los registros.');
        } else {
            getCursosActivos();

            store.dispatch({ type: "STATE_ALL_USER", allDataUser: [] })
            alertify.set('notifier', 'position', 'top-right');
            alertify.success("Registros eliminados.");
        }
    });
}


const getCursosSocio = (idSocio) => {
    getSocios(idSocio)
    //let estadoActual = store.getState().user;
    let cursoActual = store.getState().allCourse;
    if (Object.keys(cursoActual).length === 0) {
        axios({
            method: 'post',
            url: 'https://registroreevolucion.servicenext.eu/Api/Api/Academy/getCursosParaRegistrar',
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({
                "REGSPAGE": 1000,
                "PAGE": 1,
                "ORDERCOLUM": 1,
                "ORDERDIR": "A",
                "ID_SOCIO": idSocio,
            })
        }).then(function (res) {
            if (!res.data.OK) {
                if (window.location.pathname === "/") {
                    alertify.set('notifier', 'position', 'top-right');
                    alertify.warning(res.data.mensajeError);
                }
            } else {
                if (res.data.CursosParaRegistrar === null) {
                    alertify.set('notifier', 'position', 'top-right');
                    alertify.warning("No hay cursos para el socio " + idSocio);
                } else {
                 
                    store.dispatch({
                        type: "SET_STATE_SOCIO",
                        idSocio: idSocio
                    })
                    store.dispatch({
                        type: "STATE_ALL_COURSE",
                        allCourse: res.data.CursosParaRegistrar
                    })
                }
            }
        });
    }
}


const getSocios = (idSocio) => {
    //let estadoActual = store.getState().user;
    let cursoActual = store.getState().allCourse;
    if (Object.keys(cursoActual).length === 0) {
        axios({
            method: 'post',
            url: 'https://registroreevolucion.servicenext.eu/Api/api/Socio/getSocios',
            headers: {
                'Content-Type': 'application/json',
            },
            data: JSON.stringify({
                "REGSPAGE": 1000,
                "PAGE": 1,
                "ORDERCOLUM": 1,
                "ORDERDIR": "1",
                "NOMBRE": "",
                "CIF": "",
                "PROVINCIA": ""
            })
        }).then(function (res) {

            if (res.data.OK && idSocio !== "") {
                if (res.data.Lista_Socios !== null) {
                    let buscarSocio = res.data.Lista_Socios.find(socio => socio.ID === parseInt(idSocio));
                    if (buscarSocio !== undefined) {
                        store.dispatch({
                            type: "SET_NOMBRE_SOCIO",
                            nombreSocio: buscarSocio.NOMBRE_EMPRESA
                        })
                    } else {
                        store.dispatch({
                            type: "SET_NOMBRE_SOCIO",
                            nombreSocio: ""
                        })
                    }
                }

            } else {
                store.dispatch({
                    type: "SET_NOMBRE_SOCIO",
                    nombreSocio: ""
                })
            }


        });
    }
}


const getCursosActivos = () => {
    //parasrle checkactivo y quitar del otro
    store.dispatch({ type: "STATE_ALL_COURSE_ACTIVO", cursoActivo: {} })
    let activoFiltro = store.getState().activofiltroCurso;


    axios({
        method: 'post',
        url: 'https://registroreevolucion.servicenext.eu/Api/api/Academy/getCursosActivos',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            "REGSPAGE": 1000,
            "PAGE": 1,
            "ORDERCOLUM": 1,
            "ORDERDIR": "A",
            "ACTIVO": activoFiltro ? 1 : 0,
            "Token": localStorage.getItem("tokenACADEMY")
        })
    }).then(function (res) {
        if (!res.data.OK) {
            alertify.set('notifier', 'position', 'top-right');
            alertify.warning(res.data.mensajeError);
        } else {
            if (res.data.CursosParaRegistrar === null) {
                alertify.set('notifier', 'position', 'top-right');
                alertify.warning('Actualmente no hay cursos.');
            } else {
                store.dispatch({
                    type: "STATE_ALL_COURSE_ACTIVO",
                    cursoActivo: res.data.CursosParaRegistrar
                })
            }
        }
    });
}



const saveUrl = () => {
    let params = parseParams(window.location.search);

    let socio = params.socio !== undefined ? params.socio : "";
    if (socio !== "") {
        store.dispatch({
            type: "STATE_URL_WEB",
            urlweb: window.location.href
        })

    }
}




const saveFile = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }, 0)
    }
}



const showModal = () => {
    return {
        type: "SHOW_MODAL",
        visiblerespuesta: true,
    }
}

const handleOkRespuesta = () => {
    return {
        type: "HANDLE_OK_MODAL",
        visiblerespuesta: false,
    }
}

const handleCancelRespuesta = () => {
    return {
        type: "HANDLE_CANCEL_MODAL",
        visiblerespuesta: false,
    }
}

const updateStateUser = (item) => {
    return {
        type: "CHANGE_STATE_LOGIN",
        user: item
    }
}

const verificarCondicones = (e) => {
    let estado = document.getElementById("defaultUnchecked").checked;
    return {
        type: "STATE_CHECK_CONDICIONES",
        aceptoCondiciones: !estado
    }
}
const verificarActivoFiltroCurso = (e) => {
    let estado = document.getElementById("chkFitro").checked;
    return {
        type: "STATE_ACTIVO_FILTRO_CURSO",
        activofiltroCurso: estado
    }
}

const verificarInvitacion = (e) => {
    let estado = document.getElementById("chkInvitacion").checked;
    return {
        type: "STATE_CHECK_INVITACION",
        aceptoInvitacion: estado
    }
}


export {
    sendRegistroModdle, showModal, handleOkRespuesta, handleCancelRespuesta, updateStateUser, accesoAdministrador, buscarTodosLosUsuariosRegistrados, crearFichero, parseParams, eliminarRegistros, saveUrl, logOut,
    verificarCondicones, getCursosSocio, verificarInvitacion, getCursosActivos, verificarActivoFiltroCurso, getSocios
};